import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  clientsReducer,
  authReducer,
  administratorsReducer,
  eventLogsReducer,
  connectionProfilesReducer,
} from ".";

const reducers = combineReducers({
  clients: clientsReducer,
  administrators: administratorsReducer,
  eventLogs: eventLogsReducer,
  auth: authReducer,
  connectionProfiles: connectionProfilesReducer,
});

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const setupStore = (preloadedState) =>
  configureStore({
    reducer: reducers,
    preloadedState,
    devTools: process.env.NODE_ENV !== "production",
  });
